import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import React from 'react'

import Box from './box'

Tabs.Tab = Tab

Tabs.Panel = ({ value, index, children }) => <Box>{value === index && children}</Box>

Tabs.Panel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
}

export default Tabs
